module.exports = __webpack_public_path__ + "img/calculad.f83bb355.svg";